<template>
  <div>
    <div class="app-title">
      <em-view-title :crudState="$_emWorkflowListMixin_pathType"></em-view-title>
    </div>
    <section class="app-content">
      <div id="accordionFilter" class="content" v-menu-permission="'list'">
        <div class="card">
          <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
               data-parent="#accordionFilter">
            <div class="card-body">
              <form>
                <em-filter :entity="modelName" :query-api="$_emWorkflowListMixin_queryApi" ref="emListFilter"
                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div id="sithMesPrdZpp2ResultTable" class="content">
        <div class="card my-1">
          <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
               data-parent="#accordionResult">
            <div class="card-body">
                <em-table :entity="modelName" inlineActionsDisabled
                          :query-api="$_emWorkflowListMixin_queryApi"
                          :ref="modelName+'Table'"
                          with-custom-row-actions-first-column>
                    <template slot="left-header">
                        <em-button type="search"
                                   v-if="pathType === 'todo'"
                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                   :customLabel="isClaim ? '认领' : '待办'"
                                   :custom-icon="'fa ' + (isClaim ? 'fa-toggle-on' : 'fa-toggle-off')"
                                   :busy="emWorkflowListLoading"
                                   show-name
                                   @click="switchClaim">
                        </em-button>
                    </template>

                    <template slot="customRowActionsFirstColumn" slot-scope="customRowScope">
                        <em-button type="task"
                                   :busy="claimLoading"
                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                   :custom-label="isClaim ? '认领' : '处理'"
                                   @click="handleExecute(customRowScope.row)">
                        </em-button>
                    </template>
                </em-table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
  </div>
</template>
<script>
// Author Pan Yu Rou
// Date 2024-12-10 18:05:40
import emWorkflowListMixin from "@/mixin/em/workflow/list";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import EmCommonApi from "@/mixin/em/common/api";
import ClaimTaskMixins from "@/components/workflow/mixin/ClaimTaskMixins";

export default {
    name: "sithMesPrdZpp2WorkflowListView",
    mixins: [emWorkflowListMixin, emCommonGotoMixin, EmCommonApi, ClaimTaskMixins],
    computed: {
      modelName() {
        return this.$_emRouterHelperMixin_entityName
      }
    },
  };
</script>